/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Media_Deleted_FailedInputs */

const en_toast_media_deleted_failed = /** @type {(inputs: Toast_Media_Deleted_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete media`)
};

const nl_toast_media_deleted_failed = /** @type {(inputs: Toast_Media_Deleted_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij het verwijderen van media`)
};

/**
* | output |
* | --- |
* | "Failed to delete media" |
*
* @param {Toast_Media_Deleted_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_media_deleted_failed = /** @type {((inputs?: Toast_Media_Deleted_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Media_Deleted_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_media_deleted_failed(inputs)
	return en_toast_media_deleted_failed(inputs)
});